<script setup lang="ts">
import { ref } from "vue";
import { useForm } from "vee-validate";
import { useErrors } from "@/utils/api-functions";
//@ts-ignore
import FormInput from "@/components/form/input.vue";
//@ts-ignore
import Submit from "@/components/form/submit.vue";
import * as Yup from "yup";
import { nl } from "yup-locales";
import { useApiStore } from "@/stores/api";
import { useReCaptcha } from "vue-recaptcha-v3";

const props = defineProps<{ groups: any; tags: any; mailchimpGroupId: string }>();

const apiErrors = useErrors();
const apiStore = useApiStore();
const reCaptcha = useReCaptcha();

const success = ref(false);
const loading = ref(false);

Yup.setLocale(nl);

const { handleSubmit, isSubmitting } = useForm({
    initialValues: {
        email: "",
        href: window.location.href,
        pathname: window.location.pathname,
        mailchimp_ids: [],
        mailchimp_group_id: props.mailchimpGroupId,
        tags: props.tags,
    },
    validationSchema: Yup.object({
        email: Yup.string().email().required().label("Email"),
        href: Yup.string().required(),
        mailchimp_group_id: Yup.string().label("Mailchimp group ids"),
        mailchimp_ids: Yup.array().label("Mailchimp ids"),
        tags: Yup.string().label("Tags"),
        pathname: Yup.string().required(),
    }),
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    try {
        loading.value = true;

        await reCaptcha!.recaptchaLoaded();

        const token = await reCaptcha!.executeRecaptcha("login");

        // @ts-ignore
        apiStore.subscribeNewsletter({ ...values, "g-recaptcha-response": token });

        // @ts-ignore
        if (window.hasOwnProperty("dataLayer") && dataLayer) {
            // @ts-ignore
            dataLayer.push({
                event: "cf7submission",
                formId: "1563",
                response: [
                    { name: "email", value: values.email },
                    { name: "href", value: window.location.href },
                    { name: "pathname", value: window.location.pathname },
                ],
            });
        }

        success.value = true;

        setTimeout(resetForm, 500);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});
</script>

<template>
    <form id="newsletter_form" key="form" v-if="!success" @submit="onSubmit" class="grid gap-y-[16px]">
        <form-input name="email" type="email" placeholder="Email"></form-input>
        <submit :disabled="success" :loading="isSubmitting || loading">Inschrijven</submit>
        <div class="text-beige-300 text-15 font-light text-center pt-[12px]">Door je in te schrijven, ga je automatisch akkoord met onze gebruiksvoorwaarden en privacybeleid.</div>
    </form>
    <div v-else key="success" class="flex items-center justify-center flex-1 w-full text-white">
        <p class="text-center">Bedankt! We hebben uw inschrijving goed ontvangen.</p>
    </div>
</template>

<style scoped>
:deep input {
    @apply border border-white placeholder:text-white text-15 font-light;
}
</style>
